import { ImageViewerComponent } from 'src/app/component/image-viewer/image-viewer/image-viewer.component';
import { ApiService } from 'src/app/services/api.service';

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Haptics, ImpactStyle } from '@capacitor/haptics';
import { ModalController, Platform } from '@ionic/angular';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.page.html',
  styleUrls: ['./notification.page.scss'],
})
export class NotificationPage implements OnInit {
  notification;
  defaultHref = '/tecservice/home/notifications';

  constructor(
    private activatedRoute: ActivatedRoute,
    private apiService: ApiService,
    private platform: Platform,
    private modalCtrl: ModalController,
    private router: Router
  ) {}

  ngOnInit() {
    if (this.router.url.indexOf('transportec') >= 0) {
      this.defaultHref = '/tecservice-transportec/wallet/notifications';
    }
    if (this.activatedRoute.snapshot.data['special']) {
      this.notification = this.activatedRoute.snapshot.data['special'];
    }
    this.getNotification();
    this.changeStatusToRead();
  }

  getNotification() {
    this.apiService.getData('notification/' + this.activatedRoute.snapshot.paramMap.get('id')).then((res) => {
      console.log('Notification: ', res);
      this.notification = res.data;
    });
  }

  changeStatusToRead() {
    this.apiService
      .putData('endpoint', { id: this.activatedRoute.snapshot.paramMap.get('id'), read_at: 'now' })
      .then((res) => {
        console.log(res);
      });
  }

  async viewImage(src: string, title: string = '', description: string = '') {
    if (this.platform.is('ios')) {
      Haptics.impact({ style: ImpactStyle.Medium });
    }
    const modal = await this.modalCtrl.create({
      component: ImageViewerComponent,
      componentProps: {
        imgSource: src,
        imgTitle: title,
        imgDescription: description,
      },
      cssClass: 'modal-fullscreen',
      keyboardClose: true,
      showBackdrop: true,
    });

    return await modal.present();
  }
}
